module.exports = __webpack_public_path__ + "media/assets/icons/edit-d33f1b3a15f4b04289d2f09cf2661974.svg";